class Subject {
  eventType: string;
  callback: Function;
  contextName: string;
  id?: string;

  constructor(eventType: string, id: string | undefined, callback: Function, contextName: string) {
    this.eventType = eventType;
    this.callback = callback;
    this.contextName = contextName;
    this.id = id;
  }
}

export default Subject;
